import {
  ProductCategoryPayload,
  ProductDashboardItemPayload,
} from 'services/interfaces/productsExport';

export type ProductsCsvRow = Record<string, string | number>;

const CSV_COLUMNS = [
  'Id',
  'Código',
  'Nome',
  'Categoria',
  'Valor de Venda',
  'Tipo',
  'NCM',
  'CFOP',
  'CST',
  'CEST',
  'Código de Benefício Fiscal',
  'Código da Nota',
  'PIS',
  'COFINS',
  'Valor de Custo',
  'Codigo Da Natureza',
  'ICMS',
  'Redução de ICMS ',
  'Aliquota PIS',
  'Aliquota COFINS',
  'Codigo de Barra',
] as const;

function formatCurrencyBrl(value: number | string | null | undefined): string {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const parsed = parseFloat(String(value));
  if (Number.isNaN(parsed)) {
    return '';
  }

  return parsed
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}

function cellValue(value: string | number | null | undefined): string | number {
  if (value === undefined || value === null) {
    return '';
  }
  return value;
}

export function buildProductsCsvRows(
  products: ProductDashboardItemPayload[],
  categories: ProductCategoryPayload[],
): ProductsCsvRow[] {
  return products.map((item) => {
    const category = categories.find(
      (categoria) => categoria.codigo == item.categoria_id,
    );
    const categoryName = category?.nome ? category.nome.trim() : '';

    return {
      Id: item.codigo,
      Código: item.referencia ? item.referencia.trim() : '',
      Nome: item.descricao ? item.descricao.trim() : '',
      Categoria: categoryName,
      'Valor de Venda': formatCurrencyBrl(item.valor_venda),
      Tipo: item.complemento ? 'Complemento' : '',
      NCM: cellValue(item.ncm_sh),
      CFOP: cellValue(item.cfop),
      CST: cellValue(item.cst),
      CEST: cellValue(item.cest),
      'Código de Benefício Fiscal': cellValue(item.c_benef),
      'Código da Nota': cellValue(item.referencia_nota_emissao),
      PIS: cellValue(item.pis_cst),
      COFINS: cellValue(item.cofins_cst),
      'Valor de Custo': cellValue(item.valor_custo),
      'Codigo Da Natureza': cellValue(item.tipo_sped),
      ICMS: cellValue(item.p_icms),
      'Redução de ICMS ': cellValue(item.p_red_bc),
      'Aliquota PIS': cellValue(item.pis_aliq),
      'Aliquota COFINS': cellValue(item.cofins_aliq),
      'Codigo de Barra':
        item.eans && item.eans.length > 0 ? item.eans[0].ean : '',
    };
  });
}

function escapeCsvCell(value: string | number): string {
  const text = String(value);
  if (/[;"\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function serializeProductsCsv(rows: ProductsCsvRow[]): string {
  const header = CSV_COLUMNS.join(';');
  if (rows.length === 0) {
    return header;
  }

  const lines = rows.map((row) =>
    CSV_COLUMNS.map((column) => escapeCsvCell(row[column] ?? '')).join(';'),
  );

  return [header, ...lines].join('\n');
}
